import { createContext, useContext, useMemo } from 'react';
import { StandaloneTracker } from 'framework-asset-preview-lib/internal/shared/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackerContext = /*#__PURE__*/createContext(undefined);
export default function TrackerProvider({
  children
}) {
  const value = useMemo(() => ({
    tracker: StandaloneTracker
  }), []);
  return /*#__PURE__*/_jsx(TrackerContext.Provider, {
    value: value,
    children: children
  });
}
export function useTracker() {
  const context = useContext(TrackerContext);
  if (context === undefined) {
    throw new Error('useTracker must be used within a TrackerProvider');
  }
  return context;
}